// src/components/admin/AdminMarketplace.tsx
// Nova página: Marketplace com 4 abas de análise

import React, { useState } from 'react';
import { Ticket } from 'lucide-react';
import './AdminMarketplace.css';

import CouponsImpact from './cupom/CouponsImpact';
import MyCouponsTab from './cupom/MyCouponsTab';
import AllCouponsTab from './cupom/AllCouponsTab';

type MarketplaceTab =
    | 'myCoupons'
    | 'allCoupons'
    | 'couponsImpact';

interface AdminMarketplaceProps {
    onShowToast: (message: string, type: 'success' | 'error' | 'info') => void;
}

const AdminMarketplace: React.FC<AdminMarketplaceProps> = ({ onShowToast }) => {
    const [activeTab, setActiveTab] = useState<MarketplaceTab>('myCoupons');

    const tabs = [
        { id: 'myCoupons' as MarketplaceTab, label: 'Meus Cupons', icon: Ticket },
        { id: 'allCoupons' as MarketplaceTab, label: 'Controle de Cupons', icon: Ticket },
        { id: 'couponsImpact' as MarketplaceTab, label: 'Impacto de Cupons', icon: Ticket }
    ];

    return (
        <div className="admin-marketplace-container adm-page">
            <div className="adm-page-header">
                <h1 className="adm-page-title">Gerenciamento de Cupons</h1>
                <p className="adm-page-subtitle">Controle e Impacto de Cupons</p>
            </div>

            <div className="adm-tabs">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                        <button
                            key={tab.id}
                            className={`adm-tab ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            <Icon size={16} strokeWidth={1.5} />
                            <span>{tab.label}</span>
                        </button>
                    );
                })}
            </div>

            <div className="marketplace-content">

                {activeTab === 'myCoupons' && (
                    <MyCouponsTab onShowToast={onShowToast} />
                )}

                {activeTab === 'allCoupons' && (
                    <AllCouponsTab onShowToast={onShowToast} />
                )}

                {activeTab === 'couponsImpact' && (
                    <CouponsImpact onShowToast={onShowToast} />
                )}
            </div>
        </div>
    );
};

export default AdminMarketplace;